import { useDocumentTitle } from '@/app/document-title';
import { Button, EmptyState } from '@mgrvtechgroup/admin-ds';
import { KeyRoundIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { getOperatorCallbackResult } from './runtime';

export function OperatorCallbackPage() {
  useDocumentTitle();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(!getOperatorCallbackResult());
  useEffect(() => {
    let active = true;
    void getOperatorCallbackResult()?.then((result) => {
      if (!active) return;
      if (result.failed) setFailed(true);
      else void navigate(result.returnTo, { replace: true });
    });
    return () => {
      active = false;
    };
  }, [navigate]);
  return (
    <div className="p-6" aria-live="polite">
      <EmptyState
        icon={KeyRoundIcon}
        title={failed ? '로그인 정보를 확인하지 못했습니다' : '인증 확인 중입니다'}
        description={
          failed ? '운영자 로그인 화면에서 다시 시도해 주세요.' : '업무 권한을 확인하고 있습니다.'
        }
      />
      {failed && (
        <Button nativeButton={false} role="link" render={<Link to="/login?error=callback" />}>
          로그인 화면으로 이동
        </Button>
      )}
    </div>
  );
}
